import React from "react";

export default function ConfirmDeleteModal({ open, onClose, onConfirm, chatTitle }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-md p-6 animate-fadeIn">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    ยืนยันการลบแชท?
                </h2>

                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    ระบบจะทำการลบการสนทนา{" "}
                    <span className="font-semibold text-gray-900">
                        {chatTitle}...
                    </span>{" "}
                    ออกจากระบบอย่างถาวร<br />
                    <span className="text-gray-400 text-xs">
                        หากต้องการลบข้อมูลความจำหรือบันทึกเพิ่มเติม สามารถจัดการได้ในหน้าการตั้งค่า
                    </span>
                </p>

                <div className="flex justify-end gap-2 mt-6">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                    >
                        ยกเลิก
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700 shadow-sm transition"
                    >
                        ลบ
                    </button>
                </div>
            </div>
        </div>
    );
}
